import Home from "./pages/home/Home";
import Login from "./pages/login/Login";
import List from "./pages/list/List";
// import TcList from "./pages/list/TcList";
import Singlecourse from "./pages/single/Singlecourse";
import Single from "./pages/single/Single";
// import SingleTeacher from "./pages/single/SingleTeacher";
// import SingleData from "./pages/single/SingleData";
// import SingleDetail from "./pages/single/SingleDetail";
// import AllTopic from "./pages/single/AllTopic";
// import FinalTopic from "./pages/single/FinalTopic";
import New from "./pages/new/New";
import NewCourse from "./pages/newCourse/New";
import NewBlog from "./pages/newBlog/New";
import SingleBlog from "./pages/single/SingleBlog";
// import NewData from "./pages/newData/New";
// import NewDetail from "./pages/newDetail/New";
// import Detail from "./pages/detail/Detail";
// import AllDetail from "./pages/allDetail/AllDetail";
// import AllteacherDetail from "./pages/allDetail/AllteacherDetail";
// import AllcounsellorDetail from "./pages/allDetail/AllcounsellorDetail";
// import NewSession from "./pages/newSession/New";
// import NewSubTopic from "./pages/newSubTopic/New";
// import NewAllQuestion from "./pages/newAllQuestion/New";
// import NewQuestion from "./pages/newQuestion/New";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { courseInputs, userInputs,blogInputs } from "./formSource";
import "./style/dark.scss";
import { useContext } from "react";
import { DarkModeContext } from "./context/darkModeContext";
import { AuthContext } from "./context/AuthContext";
import { courseColumns, userColumns,blogColumns } from "./datatablesource";
// import NewHotel from "./pages/newHotel/NewHotel";

// import NewRoom from "./pages/newRoom/NewRoom";

function App() {
  const { darkMode } = useContext(DarkModeContext);

  const ProtectedRoute = ({ children }) => {
    const { user } = useContext(AuthContext);

    if (!user) {
      return <Navigate to="/login" />;
    }

    return children;
  };

  return (
    <div className={darkMode ? "app dark" : "app"}>
      <BrowserRouter>
        <Routes>
          <Route path="/">
            <Route path="login" element={<Login />} />
            <Route
              index
              element={
                <ProtectedRoute>
                  <Home />
                </ProtectedRoute>
              }
            />
            <Route path="users">
              <Route
                index
                element={
                  <ProtectedRoute>
                    <List columns={userColumns} />
                  </ProtectedRoute>
                }
              />
              <Route
                path=":userId"
                element={
                  <ProtectedRoute>
                    <Single />
                  </ProtectedRoute>
                }
              />
              <Route
                path="new"
                element={
                  <ProtectedRoute>
                    <New inputs={userInputs} title="Add New User" />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="courses">
              <Route
                index
                element={
                  <ProtectedRoute>
                    <List columns={courseColumns} />
                  </ProtectedRoute>
                }
              />
              <Route
                path=":courseId"
                element={
                  <ProtectedRoute>
                    <Singlecourse />
                  </ProtectedRoute>
                }
              />
              <Route
                path="new"
                element={
                  <ProtectedRoute>
                    <NewCourse inputs={courseInputs} title="Add New Course" />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="blogs">
              <Route
                index
                element={
                  <ProtectedRoute>
                    <List columns={blogColumns} />
                  </ProtectedRoute>
                }
              />
              <Route
                path=":blogId"
                element={
                  <ProtectedRoute>
                    <SingleBlog />
                  </ProtectedRoute>
                }
              />
              <Route
                path="new"
                element={
                  <ProtectedRoute>
                    <NewBlog inputs={blogInputs} title="Add New Blog" />
                  </ProtectedRoute>
                }
              />
            </Route>
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
